/**
 * External Dependencies
 */
import 'jquery';
import Letterize from 'letterizejs';
import anime from 'animejs/lib/anime.es.js';
// import Splide from '@splidejs/splide';
import 'slick-carousel';
import '../../node_modules/slick-carousel/slick/slick.css';
import 'sharer.js';

import Vue from 'vue';
import VueStoreLocator from './local_modules/@cherrypulp/vue-store-locator';

$(() => {
  $('#store').each(function () {
    Vue.use(VueStoreLocator, {
      // see config.js for all options...
      api: {
        callback: '__google_maps_api_provider__',
        channel: 'store-locator',
        client: null,
        key: 'AIzaSyALWMh9YetP10_yGENeGYFeHNASmPiwXzI',
        language: null,
        // @see https://developers.google.com/maps/documentation/javascript/libraries
        libraries: [
          // 'geometry',
          'places',
        ],
        region: null,
        version: '3.18',
      },
      stores: window.__map.stores,
      search: {
        // Set to false to deactivate autocomplete
        // @see https://developers.google.com/maps/documentation/javascript/places-autocomplete
        autocomplete: false,
        /*autocomplete: {
            componentRestrictions: {
                country: 'BE',
            },
        },*/
        select: window.__map.select,
        text: false,

        // Keys where the search will be performed (default: all)
        keys: ['Afrique', 'Belgique'],
        live: true,
        placeholder: window.__map.placeholder,
        title: window.__map.title,
      },
      /**
       * Map configuration.
       */
      map: {
        // Set to false to deactivate clusters
        // @see https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/markerclusterer.js
        clusters: false,
        /*clusters: {
                imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
                ignoreHidden: true,
                maxZoom: 10,
                styles: null,
            },*/

        geocode: false,

        // Set to false to deactivate location marker and circle
        location: false,
        /*location: {
                // Set to false to deactivate location circle
                circle: {
                    fillColor: '#213B87',
                    fillOpacity: 0.35,
                    radius: 5000,
                    strokeColor: '#213B87',
                    strokeOpacity: 0.8,
                    strokeWeight: 2,
                },
                // Set to false to deactivate location marker
                icon: 'https://www.google.com/mapfiles/marker_green.png',
            },*/
        markers: {
          // Default stores markers
          icon: {
            active: '/app/themes/fources/public/images/pin-active.svg',
            inactive: '/app/themes/fources/public/images/pin-active.svg',
          },
        },

        // @see https://developers.google.com/maps/documentation/javascript/tutorial
        options: {
          center: {
            lat: 0,
            lng: 0,
          },
          fullscreenControl: false,
          gestureHandling: 'cooperative',
          mapTypeControl: false,
          mapTypeControlOptions: false,
          scrollwheel: false,
          streetViewControl: false,
          styles: [
            {
              featureType: 'administrative',
              elementType: 'all',
              stylers: [
                {
                  saturation: '-100',
                },
              ],
            },
            {
              featureType: 'administrative.province',
              elementType: 'all',
              stylers: [
                {
                  visibility: 'off',
                },
              ],
            },
            {
              featureType: 'landscape',
              elementType: 'all',
              stylers: [
                {
                  saturation: -100,
                },
                {
                  lightness: 65,
                },
                {
                  visibility: 'on',
                },
              ],
            },
            {
              featureType: 'poi',
              elementType: 'all',
              stylers: [
                {
                  saturation: -100,
                },
                {
                  lightness: '50',
                },
                {
                  visibility: 'simplified',
                },
              ],
            },
            {
              featureType: 'road',
              elementType: 'all',
              stylers: [
                {
                  saturation: '-100',
                },
              ],
            },
            {
              featureType: 'road.highway',
              elementType: 'all',
              stylers: [
                {
                  visibility: 'simplified',
                },
              ],
            },
            {
              featureType: 'road.arterial',
              elementType: 'all',
              stylers: [
                {
                  lightness: '30',
                },
              ],
            },
            {
              featureType: 'road.local',
              elementType: 'all',
              stylers: [
                {
                  lightness: '40',
                },
              ],
            },
            {
              featureType: 'transit',
              elementType: 'all',
              stylers: [
                {
                  saturation: -100,
                },
                {
                  visibility: 'simplified',
                },
              ],
            },
            {
              featureType: 'water',
              elementType: 'geometry',
              stylers: [
                {
                  hue: '#ffff00',
                },
                {
                  lightness: -25,
                },
                {
                  saturation: -97,
                },
              ],
            },
            {
              featureType: 'water',
              elementType: 'labels',
              stylers: [
                {
                  lightness: -25,
                },
                {
                  saturation: -100,
                },
              ],
            },
          ],
          zoom: 2,
        },
      },
      templates: {
        // vue template
        card: `<a class="card--projet mb-4" href="#store" :data-cat="store.cat">
                <h2 class="card--projet--title" v-html="store.title"></h2>
                <div class="card--projet--body" v-html="store.text"></div>
                <span class="card--projet--link">{{ store.more }} +</span>
            </a>`,
        // simple template with {{name}}
        infoWindow: `<div class="card--projet">
                <h2 class="has-h-3-font-size">Infos générales</h2>
                <h3 class="card--projet--title">{{title}}</h3>
                {{text}}
                <h2 class="has-h-3-font-size">Description</h2>
                {{description}}
                <a href="{{button_link}}" class="">{{button_text}}</a>
            </div>`,
      },
    });

    new Vue({
      el: '#store',
    });
  });

  nav();

  animation();

  sliders();

  tabs();

  $('.js-dropdown').each(function () {
    const $this = $(this);
    const $button = $this.find('button');
    const $ul = $this.find('ul');

    $button.on('click', function () {
      $ul.slideToggle();
    });
  });
});

// splide();

function tabs() {
  $('.block-tabs__dropdown').each(function () {
    const $this = $(this);
    const $button = $this.find('button');

    $button.on('click', function () {
      console.log('click');
      $this.find('ul').toggleClass('active');
    });
  });
}

function nav() {
  $('#nav-primary').each(function () {
    const $this = $(this);
    const $nav = $this.find('.nav-primary');
    const $button = $('#toggle-nav');
    const $buttonSearch = $this.find('button.search-desktop');
    const $searchDesktop = $this.find('form.search-desktop');

    $button.on('click', function () {
      $button.toggleClass('active');
      $nav.toggleClass('active');
    });

    $(window).on('scroll', function () {
      const scroll = $(window).scrollTop();

      if (scroll > 50) {
        $this.addClass('nav--scrolled');
      } else {
        $this.removeClass('nav--scrolled');
      }
    });

    $buttonSearch.on('click', function () {
      if ($(window).width() > 1024) {
        $searchDesktop.fadeToggle();
      }
    });

    $(window).on('resize', function () {
      $searchDesktop.hide();
    });
  });
}

function sliders() {
  $('.slick:not(.slick--pdf)').slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    dots: false,
    arrows: true,
    nextArrow:
      '<button type="button" class="slick-next"><svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M-4.59001e-07 10.5007C-4.76389e-07 10.103 0.158017 9.72147 0.439291 9.4402C0.720564 9.15893 1.10205 9.00091 1.49983 9.00091L18.8769 9.00091L12.4366 2.56363C12.2972 2.42418 12.1865 2.25863 12.1111 2.07643C12.0356 1.89424 11.9968 1.69896 11.9968 1.50175C11.9968 1.30454 12.0356 1.10926 12.1111 0.927061C12.1865 0.744863 12.2972 0.579315 12.4366 0.439866C12.5761 0.300418 12.7416 0.189802 12.9238 0.114334C13.106 0.0388636 13.3013 2.23068e-05 13.4985 2.22981e-05C13.6957 2.22895e-05 13.891 0.0388635 14.0732 0.114333C14.2554 0.189802 14.4209 0.300418 14.5604 0.439866L23.5594 9.43886C23.699 9.57818 23.8099 9.74369 23.8855 9.92591C23.9611 10.1081 24 10.3035 24 10.5007C24 10.698 23.9611 10.8934 23.8855 11.0756C23.8099 11.2578 23.699 11.4233 23.5594 11.5626L14.5604 20.5616C14.4209 20.7011 14.2554 20.8117 14.0732 20.8872C13.891 20.9626 13.6957 21.0015 13.4985 21.0015C13.3013 21.0015 13.106 20.9626 12.9238 20.8872C12.7416 20.8117 12.5761 20.7011 12.4366 20.5616C12.155 20.28 11.9968 19.898 11.9968 19.4997C11.9968 19.3025 12.0356 19.1072 12.1111 18.925C12.1865 18.7429 12.2972 18.5773 12.4366 18.4379L18.8769 12.0006L1.49983 12.0006C1.10205 12.0006 0.720564 11.8426 0.439291 11.5613C0.158017 11.28 -4.41614e-07 10.8985 -4.59001e-07 10.5007Z" fill="black"/></svg></button>',
    prevArrow:
      '<button type="button" class="slick-prev"><svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M24 10.5007C24 10.8985 23.842 11.28 23.5607 11.5613C23.2794 11.8425 22.8979 12.0006 22.5002 12.0006L5.12311 12.0006L11.5634 18.4378C11.7028 18.5773 11.8135 18.7428 11.8889 18.925C11.9644 19.1072 12.0032 19.3025 12.0032 19.4997C12.0032 19.6969 11.9644 19.8922 11.8889 20.0744C11.8135 20.2566 11.7028 20.4221 11.5634 20.5616C11.4239 20.701 11.2584 20.8117 11.0762 20.8871C10.894 20.9626 10.6987 21.0014 10.5015 21.0014C10.3043 21.0014 10.109 20.9626 9.92682 20.8871C9.74462 20.8117 9.57907 20.701 9.43962 20.5616L0.440629 11.5626C0.300956 11.4233 0.190141 11.2578 0.11453 11.0756C0.038919 10.8933 -4.67625e-07 10.698 -4.59001e-07 10.5007C-4.50378e-07 10.3034 0.038919 10.1081 0.11453 9.92588C0.190141 9.74367 0.300956 9.57816 0.44063 9.43884L9.43963 0.439845C9.57907 0.300397 9.74462 0.18978 9.92682 0.114312C10.109 0.0388428 10.3043 -5.98658e-07 10.5015 -5.90038e-07C10.6987 -5.81418e-07 10.894 0.0388429 11.0762 0.114312C11.2584 0.189781 11.4239 0.300397 11.5634 0.439845C11.845 0.721474 12.0032 1.10344 12.0032 1.50173C12.0032 1.69894 11.9644 1.89422 11.8889 2.07641C11.8135 2.25861 11.7028 2.42416 11.5634 2.56361L5.12311 9.00089L22.5002 9.00089C22.8979 9.00089 23.2794 9.15891 23.5607 9.44018C23.842 9.72145 24 10.1029 24 10.5007Z" fill="black"/></svg></button>',
    responsive: [
      {
        breakpoint: 720,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  const winWidth = $(window).width();
  console.log(winWidth);
  if (winWidth < 720) {
    $('.slick--pdf').slick({
      infinite: false,
      slidesToShow: 2,
      slidesToScroll: 2,
      dots: false,
      arrows: true,
      nextArrow:
        '<button type="button" class="slick-next"><svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M-4.59001e-07 10.5007C-4.76389e-07 10.103 0.158017 9.72147 0.439291 9.4402C0.720564 9.15893 1.10205 9.00091 1.49983 9.00091L18.8769 9.00091L12.4366 2.56363C12.2972 2.42418 12.1865 2.25863 12.1111 2.07643C12.0356 1.89424 11.9968 1.69896 11.9968 1.50175C11.9968 1.30454 12.0356 1.10926 12.1111 0.927061C12.1865 0.744863 12.2972 0.579315 12.4366 0.439866C12.5761 0.300418 12.7416 0.189802 12.9238 0.114334C13.106 0.0388636 13.3013 2.23068e-05 13.4985 2.22981e-05C13.6957 2.22895e-05 13.891 0.0388635 14.0732 0.114333C14.2554 0.189802 14.4209 0.300418 14.5604 0.439866L23.5594 9.43886C23.699 9.57818 23.8099 9.74369 23.8855 9.92591C23.9611 10.1081 24 10.3035 24 10.5007C24 10.698 23.9611 10.8934 23.8855 11.0756C23.8099 11.2578 23.699 11.4233 23.5594 11.5626L14.5604 20.5616C14.4209 20.7011 14.2554 20.8117 14.0732 20.8872C13.891 20.9626 13.6957 21.0015 13.4985 21.0015C13.3013 21.0015 13.106 20.9626 12.9238 20.8872C12.7416 20.8117 12.5761 20.7011 12.4366 20.5616C12.155 20.28 11.9968 19.898 11.9968 19.4997C11.9968 19.3025 12.0356 19.1072 12.1111 18.925C12.1865 18.7429 12.2972 18.5773 12.4366 18.4379L18.8769 12.0006L1.49983 12.0006C1.10205 12.0006 0.720564 11.8426 0.439291 11.5613C0.158017 11.28 -4.41614e-07 10.8985 -4.59001e-07 10.5007Z" fill="black"/></svg></button>',
      prevArrow:
        '<button type="button" class="slick-prev"><svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M24 10.5007C24 10.8985 23.842 11.28 23.5607 11.5613C23.2794 11.8425 22.8979 12.0006 22.5002 12.0006L5.12311 12.0006L11.5634 18.4378C11.7028 18.5773 11.8135 18.7428 11.8889 18.925C11.9644 19.1072 12.0032 19.3025 12.0032 19.4997C12.0032 19.6969 11.9644 19.8922 11.8889 20.0744C11.8135 20.2566 11.7028 20.4221 11.5634 20.5616C11.4239 20.701 11.2584 20.8117 11.0762 20.8871C10.894 20.9626 10.6987 21.0014 10.5015 21.0014C10.3043 21.0014 10.109 20.9626 9.92682 20.8871C9.74462 20.8117 9.57907 20.701 9.43962 20.5616L0.440629 11.5626C0.300956 11.4233 0.190141 11.2578 0.11453 11.0756C0.038919 10.8933 -4.67625e-07 10.698 -4.59001e-07 10.5007C-4.50378e-07 10.3034 0.038919 10.1081 0.11453 9.92588C0.190141 9.74367 0.300956 9.57816 0.44063 9.43884L9.43963 0.439845C9.57907 0.300397 9.74462 0.18978 9.92682 0.114312C10.109 0.0388428 10.3043 -5.98658e-07 10.5015 -5.90038e-07C10.6987 -5.81418e-07 10.894 0.0388429 11.0762 0.114312C11.2584 0.189781 11.4239 0.300397 11.5634 0.439845C11.845 0.721474 12.0032 1.10344 12.0032 1.50173C12.0032 1.69894 11.9644 1.89422 11.8889 2.07641C11.8135 2.25861 11.7028 2.42416 11.5634 2.56361L5.12311 9.00089L22.5002 9.00089C22.8979 9.00089 23.2794 9.15891 23.5607 9.44018C23.842 9.72145 24 10.1029 24 10.5007Z" fill="black"/></svg></button>',
    });
  }
}

function letterize() {
  const $this = $('.typewriter');
  var characters = $this.text().split('');

  $this.empty();
  $.each(characters, function (i, el) {
    console.log(characters);
    $this.append('<span>' + el + '</span');
  });

  //   var string = "Selected<br>Works",
  //     result = string.replace(/(?![^<]*>)[^<]/g, c => `<span>${c}</span>\n`);

  // console.log(result);
}

function animation() {
  if ($(window).width() > 768) {
    const animates = document.querySelectorAll('.animate');
    let options = {
      // root: null,
      // rootMargin: '0px',
      threshold: 0.25,
    };
    let observer = new IntersectionObserver(function (entries, observer) {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return;
        }
        let delay = 0;
        // console.log('1111', entry.target.className.match(/delay-\d+/)[0]);

        if (entry.target.className.match(/delay-\d+/)) {
          delay = entry.target.className
            .match(/delay-\d+/)[0]
            .replace('delay-', '');
        }
        if (entry.target.classList.contains('typewriter')) {
          typewriter(entry.target, delay);
        }
        if (entry.target.classList.contains('counter')) {
          countAnimation(entry.target, delay);
        }
        if (entry.target.classList.contains('fade-up')) {
          fadeUp(entry.target, delay);
        }
        if (entry.target.classList.contains('fade-up-image')) {
          if (entry.target.classList.contains('is-style-logo')) {
            fadeUpImageLogo(entry.target, delay);
          } else {
            fadeUpImage(entry.target, delay);
          }
        }
        if (entry.target.classList.contains('fade-left')) {
          fadeLeft(entry.target, delay);
        }
        if (entry.target.classList.contains('fade-right')) {
          fadeRight(entry.target, delay);
        }
        observer.unobserve(entry.target);
      });
    }, options);

    animates.forEach((animate) => {
      observer.observe(animate);
    });
  }
}

function fadeUp(target, delay) {
  var tl = anime.timeline({
    loop: false,
    autoplay: true,
    delay: delay,
  });

  tl.add({
    targets: target,
    translateY: [100, 0],
    opacity: [0, 1],
    easing: 'easeInOutExpo',
    duration: 1400,
  });
}

function typewriter(target, delay) {
  var string = $(target).html();
  var result = string
    .replace(/(?![^<]*>)[^<]/g, (c) => `<span class="letter">${c}</span>`)
    .replace(
      '<span class="bg">',
      '<span class="bg"><span class="bg__after"></span>'
    )
    .replace(
      '<span class="bg-black">',
      '<span class="bg-black"><span class="bg-black__after"></span>'
    );
  $(target).html(result);

  setTimeout(function () {
    var tl = anime.timeline({
      loop: false,
      autoplay: true,
      delay: delay,
    });

    tl.add({
      targets: target,
      opacity: [0, 1],
      easing: 'easeInOutExpo',
      duration: 1,
    });
    tl.add({
      targets: target.querySelectorAll('.letter'),
      opacity: [0, 1],
      easing: 'easeInOutExpo',
      duration: 5,
      delay: anime.stagger(20),
    })
      .add({
        targets: target.querySelectorAll('.bg__after'),
        scaleX: [0, 1],
        duration: 150,
        easing: 'linear',
        delay: 200,
      })
      .add({
        targets: target.querySelectorAll('.bg-black__after'),
        scaleX: [0, 1],
        duration: 150,
        easing: 'linear',
        delay: 200,
      });
  }, 500);
}

function fadeUpImage(target, delay) {
  var tl = anime.timeline({
    loop: false,
    autoplay: true,
    delay: delay,
  });

  tl.add({
    targets: target.querySelectorAll('img'),
    translateY: ['100%', 0],
    scale: [1, 1.1],
    easing: 'easeInOutExpo',
    duration: 1400,
  });
}

function fadeUpImageLogo(target, delay) {
  var tl = anime.timeline({
    loop: false,
    autoplay: true,
    delay: delay,
  });

  tl.add({
    targets: target.querySelectorAll('img'),
    translateY: ['100%', '-50%'],
    translateX: ['-50%', '-50%'],
    opacity: [0, 1],
    scale: [1, 1.1],
    easing: 'easeInOutExpo',
    duration: 1400,
  });
}

function fadeLeft(target, delay) {
  var tl = anime.timeline({
    loop: false,
    autoplay: true,
    delay: delay,
  });

  tl.add({
    targets: target,
    translateX: [-100, 0],
    opacity: [0, 1],
    easing: 'easeInOutExpo',
    duration: 1400,
  });
}

function fadeRight(target, delay) {
  var tl = anime.timeline({
    loop: false,
    autoplay: true,
    delay: delay,
  });

  tl.add({
    targets: target,
    translateX: [100, 0],
    opacity: [0, 1],
    easing: 'easeInOutExpo',
    duration: 1400,
  });
}

function imageFull() {
  $('.image-full-left').each(function () {
    $(this).css('margin-left', -screenMargin());
  });

  $('.image-full-right').each(function () {
    $(this).css('margin-right', -screenMargin());
  });
}

function screenMargin() {
  const windowWidth = $(window).width();
  const containerWidth = $('.container').width();
  const screenMargin = (windowWidth - containerWidth) / 2;

  return screenMargin;
}

function countAnimation(target) {
  function animate(obj, initVal, lastVal, duration) {
    let startTime = null;
    let plus = false;
    if (obj.innerHTML.indexOf('+') !== -1) {
      plus = true;
    }

    //get the current timestamp and assign it to the currentTime variable
    let currentTime = Date.now();

    //pass the current timestamp to the step function
    const step = (currentTime) => {
      //if the start time is null, assign the current time to startTime
      if (!startTime) {
        startTime = currentTime;
      }

      //calculate the value to be used in calculating the number to be displayed
      const progress = Math.min((currentTime - startTime) / duration, 1);

      //calculate what to be displayed using the value gotten above
      if (plus) {
        obj.innerHTML =
          Math.floor(progress * (lastVal - initVal) + initVal) + '+';
      } else {
        obj.innerHTML = Math.floor(progress * (lastVal - initVal) + initVal);
      }

      //checking to make sure the counter does not exceed the last value (lastVal)
      if (progress < 1) {
        window.requestAnimationFrame(step);
      } else {
        window.cancelAnimationFrame(window.requestAnimationFrame(step));
      }
    };

    //start animating
    window.requestAnimationFrame(step);
  }

  animate(target, 0, $(target).html(), 2000);
}
